import { ICubeSchemaMapper } from '../cube-schema-mapper.interface';

export interface IDurationAvgScoresMapper extends ICubeSchemaMapper {}
